export class PaymentSecuritiesEventType {
	
	static INIT = 'PAYMENT_INIT';

	static STEPS = {
		PAYMENT_DATA: 'PAYMENT_DATA',
		CONFIRM_PAYMENT: 'CONFIRM_PAYMENT',
		PAYMENT_RESULT: 'PAYMENT_RESULT'
	};

	static MODAL = {
		TRUE_MODAL: 'TRUE_MODAL'
	};

	static TRANSFER = {
		SEND: 'SEND',
		CONFIRM: 'CONFIRM'
	};

	static QUICK_PAYMENT = {
		QUICK_PAYMENT: 'QUICK_PAYMENT'
	};

	static SEND = {
		PAYMENT_DATA_SEND: 'PAYMENT_DATA_SEND',
		PAYMENT_DATA_CONFIRM: 'PAYMENT_DATA_CONFIRM'
	};

	static ERROR = 'PAYMENT_ERROR';
	static BUTTONS = 'PAYMENT_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities.event.type.ts